import { HeroImageContainer, Button, HeroSectionOne, HeroSectionTwo, ImageSection } from './HeroImage.style'
import ImageSectionOne from '../../assets/HeroImage/section-one.png'
import ImageSectionTwo from '../../assets/HeroImage/section-two.png'
import Background from '../../assets/HeroImage/Background.png'

const HeroImage = () => {
  return(
    <HeroImageContainer>
      <HeroSectionOne>
        <ImageSection>
          <img src={Background} />
        </ImageSection>
        <h1>Eupha</h1>
        <p>Somos una familia que trabaja con la representación exclusiva de diversos laboratorios de renombre a nivel mundial.</p>
        <Button>Iniciar Sesión</Button>
        <img src={ImageSectionOne} />
      </HeroSectionOne>
      <HeroSectionTwo>
        <h1>Pharma</h1>
        <p>Enfoque de salud que combina lo medicina convencional con terapias complementarias y alternativas, buscando tratar a la persona de manera holística.</p>
        <Button>Iniciar Sesión</Button>
        <img src={ImageSectionTwo} />
      </HeroSectionTwo>
    </HeroImageContainer>
  )
}

export default HeroImage